import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import('@/pages/index/index.vue'),
  },
  {
    path: "/aboutus",
    component: () => import('@/pages/aboutus.vue'),
  },
  {
    path: "/services",
    component: () => import('@/pages/services.vue'),
  },
  {
    path:"/team",
    component:() => import('@/pages/team.vue')
  },
  {
    path:"/rooms",
    component:() => import('@/pages/rooms.vue')
  },
  {
    path:"/room-detail",
    component:() => import('@/pages/room-detail.vue')
  },
  {
    path:"/room-detail/:id",
    component:() => import('@/pages/room-detail.vue'),
    props: true
  },
  {
    path:"/maintenance",
    component:() => import('@/pages/special/maintenance')
  },
  {
    path:"/error",
    component:() => import('@/pages/special/error')
  },
  {
    path:"/contactus",
    component:() => import('@/pages/contactus')
  },
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;